import type { EntityTag } from '@/features/tags/tags';
import { Icon } from '@/ui/icons/icon';
import { GeneralTag } from '@/ui/tag/general-tag';

import { getCategoryIcon } from '../../../features/modals/manage-tags-modal/helpers/get-category-icon';

import { TagsOverflowContainer } from './tags-overflow-container';
import type { EditStampProps } from '@/features/companies/overview/edit-stamp';

export const TagsWidget = ({
  tags,
  onEditClick,
  subHeader,
  widgetHeight,
  disabled = false,
  showEditStamp,
  editStampProps,
  testId,
  className,
  editable = true,
  header,
}: {
  tags: EntityTag[];
  onEditClick: () => void;
  subHeader?: string;
  widgetHeight: number;
  disabled?: boolean;
  showEditStamp?: boolean;
  editStampProps?: EditStampProps;
  testId?: string;
  className?: string;
  editable?: boolean;
  header?: React.ReactNode;
}) => {
  return (
    <TagsOverflowContainer
      dataTestId={testId}
      onEditClick={onEditClick}
      subHeader={subHeader}
      header={header}
      widgetHeight={widgetHeight}
      disabled={disabled}
      showEditStamp={showEditStamp}
      editStampProps={editStampProps}
      editable={editable}
      className={className}
    >
      {tags.map(tag => (
        <GeneralTag key={tag.id} variant="blue" size="l">
          {tag.name.toLowerCase()}
          {tag.category && (
            <Icon
              icon={getCategoryIcon(tag.category.name)}
              height="18px"
              width="18px"
            />
          )}
        </GeneralTag>
      ))}
    </TagsOverflowContainer>
  );
};
